module.exports = "/img/32.69dac8.webp";